import React, {useState} from 'react'
import {CheckIcon, SelectorIcon} from '@heroicons/react/solid'
import {Combobox as HeadlessCombobox} from '@headlessui/react'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Combobox({options, value, onChange, optionKey = (option) => option, display = (option) => option, label}) {

    const [query, setQuery] = useState('');

    const selected = options.find(item => optionKey(item) === value);

    const filtered = query === '' ? options : options.filter((item) => {
        return display(item).toLowerCase().includes(query.toLowerCase())
    });

    return (
        <HeadlessCombobox as="div" value={selected} onChange={onChange}>
            <HeadlessCombobox.Label className="block text-sm font-medium text-gray-700">
                {label}
            </HeadlessCombobox.Label>

            <div className="relative mt-1">
                <HeadlessCombobox.Input
                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                    onChange={(event) => setQuery(event.target.value)}
                    displayValue={item => display(item)}
                />
                <HeadlessCombobox.Button
                    className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                    <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                </HeadlessCombobox.Button>

                {filtered.length > 0 && (
                    <HeadlessCombobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {filtered.map((item) => (
                            <HeadlessCombobox.Option
                                key={item}
                                value={item}
                                className={({active}) =>
                                    classNames(
                                        'relative cursor-default select-none py-2 pl-3 pr-9',
                                        active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                                    )
                                }
                            >
                                {({active, selected}) => (
                                    <>
                                        <span className={classNames('block truncate', selected && 'font-semibold')}>
                                            {display(item)}
                                        </span>

                                        {selected && (
                                            <span
                                                className={classNames(
                                                    'absolute inset-y-0 right-0 flex items-center pr-4',
                                                    active ? 'text-white' : 'text-indigo-600'
                                                )}
                                            >
                                                <CheckIcon className="h-5 w-5" aria-hidden="true"/>
                                            </span>
                                        )}
                                    </>
                                )}
                            </HeadlessCombobox.Option>
                        ))}
                    </HeadlessCombobox.Options>
                )}
            </div>
        </HeadlessCombobox>
    )
}
